import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class AcVoucherTypeService {
    public static readonly gridDataTask = 4054;

    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 4055
     * @returns page get for acvouchertypes.
     */
    public async getAcVoucherTypes(): Promise<AcVoucherTypesGet> {
        return (await this.datatask.Post(4055))[0];
    }
}

export interface AcVoucherTypesGet {
    show_setting: '1' | '0';
}

export interface AcVoucherTypeGridRow {
    _uuid: string;
    acvouchertype_id: string;
    acvouchertype_name: string;
    account_no_db: number;
    account_no_cr: number;
    input_note: string;
    input_valuta: string;
    balance_pr_transdate: string;
    balance_pr_voucher_no: string;
    show_cust_name: string;
    show_supplier_name: string;
    show_voucherdate: string;
    show_transdate: string;
    show_duedate: string;
    show_rem_invoice_no: string;
    show_valuta_id: string;
    show_amount_invval_abs: string;
    show_kid: string;
    show_bankaccount: string;
    show_project_name: string;
    show_department_id: string;
    show_equipment_name: string;
    show_labour_no: string;
    show_businessco_no: string;
    show_invoice_no: string;
}
